





	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { IProgram, ICourse, SearchType } from '../Scripts/ISearchService';

	// Still unsure if it is ok to remove - import { BvEvent } from 'bootstrap-vue';

	import FavoritesSlider from './FavoritesSlider.vue';

	import ActionTracker, { OpenSearchGridEvent, CloseSearchGridEvent } from '../Scripts/AnalyticsEvents';

@Component({
	components: {
		FavoritesSlider
	}
})
	export default class GridVue extends Vue {
	@Prop() public items!: IProgram[] | ICourse[];
	@Prop() public searchType!: SearchType;

	private version = 1;

	get title (): string {
		const plural = this.items.length === 1 ? '' : 's';
		return `Grid View - ${this.items.length} ${this.entityName}${plural}`;
	}

	// same code appears in search summary
	get entityName (): string {
		switch (this.searchType) {
			case SearchType.Course: return 'Course';
			case SearchType.Program: return 'Program';
			default: return 'Unknown Type';
		}
	}

	private open () {
		ActionTracker.track(new OpenSearchGridEvent());
	}

	private close () {
		ActionTracker.track(new CloseSearchGridEvent(this.$router));
	}
	}
